import { computed } from 'vue';

import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { useInputStore } from '@/features/Sparten';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import get from 'lodash/get';
import { useGlobalStore } from '@/features/Global/store';

export const handleAsBoolean = (value: string | boolean): value is boolean =>
  typeof value === 'boolean';

export const hasPreviousDamage = computed(() => {
  const value = useInputStore().vorschaden;
  if (handleAsBoolean(value)) {
    return value;
  }

  return getSimpleChoiceMeta(
    SIMPLE_CHOICE.VORSCHADEN,
    SIMPLE_CHOICE_META.VORSCHADEN_EXISTS,
  ).includes(useInputStore().vorschaden);
});

export const hasPreviousDamageWithLessThanTwoDamages = computed(() => {
  if (useGlobalStore().sparte === 'res') {
    return true;
  }

  return (
    hasPreviousDamage.value &&
    !getSimpleChoiceMeta(
      SIMPLE_CHOICE.VORSCHADEN,
      SIMPLE_CHOICE_META.VORSCHADEN_MORE_THAN_TWO_DAMAGES,
    ).includes(useInputStore().vorschaden)
  );
});

export const getSumValFromPath = (fieldPath: string) =>
  get(useInputStore().vorschaeden, fieldPath, 0);

// w/o elementar and glas damages, relevant for backend calls
export const previousDamageCount = computed(() => {
  let sum = 0;
  const { vorschaeden } = useInputStore();

  if (vorschaeden.leitungswasser === true) {
    sum += getSumValFromPath('leitungswasserAnzahl');
  }
  if (vorschaeden.sturmHagel === true) {
    sum += getSumValFromPath('sturmHagelAnzahl');
  }

  if (vorschaeden.feuerBlitz === true) {
    sum += getSumValFromPath('feuerBlitzAnzahl');
  }

  if (vorschaeden.sonstige === true) {
    sum += getSumValFromPath('sonstigeAnzahl');
  }

  return sum;
});

// includes elementar and glas damages
export const previousDamageCountTotal = computed(() => {
  if (useInputStore().vorschaeden === undefined) {
    return 0;
  }

  let basePreviousDamageCount = previousDamageCount.value;

  if (
    useInputStore().absicherungen.glasversicherung === true &&
    useInputStore().vorschaeden.glas === true
  ) {
    basePreviousDamageCount += getSumValFromPath('glasAnzahl');
  }

  if (
    useInputStore().absicherungen.elementar === true &&
    useInputStore().vorschaeden.elementar === true
  ) {
    basePreviousDamageCount += getSumValFromPath('elementarAnzahl');
  }

  return basePreviousDamageCount;
});
